import React from "react";
import { Grid} from "@material-ui/core";

// styles
import useStyles from "./styles";

export default function Error() {
  var classes = useStyles();

  return (
    <Grid container className={classes.container}>
        <div className={classes.privacyContainer}>
            <div className={classes.policyContainer}>
                <h1 className={classes.header}>Privacy Policy</h1>
                <hr className={classes.line}/>
                <p>This is the Privacy Policy of CreedApp for its web and mobile software application.</p>
                <p> 
                    The Company is dedicated to protecting the privacy rights of users the App. The Company’s policies with respect to the handling of 
                    personal information with respect to the App are described within this privacy policy (the “Privacy Policy”).
                </p>
                <p>
                    You acknowledge and agree that by downloading, installing, or using the App, you shall comply with the terms and conditions of 
                    this Privacy Policy posted by the Company, on its website at <a href="http://creedapp.com">http://creedapp.com</a> from time to time (as the same may be amended from time 
                    to time). By clicking “I Accept,” you acknowledge that you have read and understood the Privacy Policy set forth or referenced herein 
                    and agree to be bound by it. IF YOU DO NOT AGREE TO BE BOUND BY THIS PRIVACY POLICY, PLEASE REFRAIN FROM ANY FURTHER USE OF OR ACCESS 
                    TO THE APP AND DELETE ANY COPIES OF THE APP IN YOUR POSSESSION OR CONTROL. The Company reserves the right at any time and from time to time, 
                    to modify the Privacy Policy (each a “Modification” and, a collectively, the “Modifications”) by posting revisions on the App. Any Modifications 
                    will be effective immediately upon such posting. You acknowledge and agree that your use of, or access to, the App after such modified Privacy 
                    Policy is posted will signify your acceptance of the Modifications and your agreement to be bound by it. Notwithstanding the foregoing,  
                    any Modification made to the Privacy Policy shall not apply to any dispute between you and the Company arising prior to the date on which  
                    the Company posted the revised Privacy Policy that contains such Modification.
                </p>
                <br/>
                <h3>JURISDICTIONAL ISSUES</h3>
                <hr className={classes.line}/>
                <p>
                    The App is controlled by the Company from the United States; accordingly, this Privacy Policy, and our collection, use, and 
                    disclosure of a user’s information, is governed by U.S. law, and not by the laws of any country, territory, or jurisdiction other than 
                    the United States. The Company does not represent or warrant that the App, or any functionality or feature thereof, is appropriate or 
                    available for use in any particular jurisdiction. Those who choose to access or use the App do so on their own initiative and at their own risk, 
                    and are responsible for complying with all local laws, rules, and regulations. By using the App and submitting any personal information, users 
                    from outside the United States (i) acknowledge that the App is subject to U.S. law; and (ii) consent to the transfer of personal information to 
                    the United States, which may provide a different level of data security than in their country of residence; and (iii) waive any claims that may 
                    arise under their own national laws. 
                </p>
                <br/>
                <h3>INFORMATION COLLECTED</h3>
                <hr className={classes.line}/>
                <p>
                    The Company automatically collects technical data and related information about the user’s device, operating system, and 
                    application software that is gathered periodically to facilitate the provision of application updates, product support, and other 
                    services to the user of the App. This information does not identify the user. 
                </p>
                <p>
                    The Company automatically collects anonymous information about the use of the App, such as information indicating that the 
                    App has been downloaded. This data helps the Company improve its content and overall usage. The information is not shared 
                    with other organizations for their independent use. 
                </p>
                <p>The data and information describe in this Section is collectively referred to as “Automatically-Collected Information.” </p>
                <p>
                    The Company collects personally identifiable information that the user provides into and through the App (“User Provided Information”). 
                    This may include demographic information, specifically name and email address. This information resides on the Company’s server.
                </p>
                <p>The Company may use this information:</p>
                <ul>
                    <li>To respond to your inquiries and fulfill your requests.</li>
                    <li>To send you administrative information, including information regarding the Applications and changes to the Company’s terms, conditions, and policies.</li>
                    <li>
                        For its business purposes, such as quality assessment, data analysis, audits, development of new products, enhancement of the App, 
                        improvement of services, and identification of usage trends.
                    </li>
                    <li>To enforce the Company’s terms and conditions and</li>
                    <li>To protect the rights, privacy, safety, or property of the Company, you, or others.</li>
                </ul>
                <br/>
                <h3>INFORMATION NOT COLLECTED</h3>
                <hr className={classes.line}/>
                <p>
                    This Application is not supported by advertising and does not use the data it collects for advertising purposes. 
                    The App does not collect personally identifiable information about a user’s online activities over time and across 
                    third-party Web sites or online services. The App does not collect information about the location of a user’s mobile device. 
                </p>
                <br/>
                <h3>THIRD PARTY ACCESS TO USER INFORMATION</h3>
                <hr className={classes.line}/>
                <p>
                    The Company will share user information with third parties only in the ways that are described in this Privacy Policy. 
                    The Company may disclose User-Provided and Automatically-Collected Information:
                </p>
                <ul>
                    <li>As required by law, such as to comply with a subpoena, or similar legal process.</li>
                    <li>
                        When the Company believes in good faith that disclosure is necessary to protect its rights, protect users’ 
                        safety or the safety of others, investigate fraud, or respond to a government request.
                    </li>
                    <li>
                        With the Company’s trusted services providers who work on its behalf, do not have an independent use for the 
                        information disclosed to them, and have agreed to adhere to the rules set forth in this Privacy Policy.
                    </li>
                    <li>
                        If the Company is involved in a merger, acquisition, or sale of all or a portion of its assets, in which 
                        case users will be notified via a prominent notice on the Company’s Web site of any change in ownership or 
                        uses of this information, as well as any choices users may have regarding this information or
                    </li>
                    <li>
                        As otherwise provided in this Privacy Policy. Users may share User-Provided Information with the third 
                        parties authorized by the user, at the user’s discretion.
                    </li>
                </ul>
                <p>
                    Please note that the App may include the ability to submit certain information directly to third-party services. 
                    If the user uses such functionality, such third-party services’ collection, use, and disclosure of such directly 
                    accessed or submitted information will be subject to such services’ applicable privacy policies, and not to this Privacy Policy. 
                </p>
                <br/>
                <h3>DATA RETENTION</h3>
                <hr className={classes.line}/>
                <p>
                    The Company will retain User-Provided Information until the user deletes or edits the User-Provided Information in the user’s App record. 
                    A user may also contact The Company at the contact information provided below to request the deletion of User-Provided Information. 
                    Once such information is deleted, the Company will not retain a copy of such User Provided Information, except as required by law. 
                </p>
                <br/>
                <h3>USER MANAGEMENT</h3>
                <hr className={classes.line}/>
                <p>
                    A user may edit or delete any and all of the User-Provided Information through the App. Notwithstanding 
                    the foregoing, please note that some or all of the User-Provided Information may be required in order for the 
                    App to function properly, and the Company may be required by law to retain certain information. 
                </p>
                <br/>
                <h3>CHILDREN</h3>
                <hr className={classes.line}/>
                <p>
                    The Company does not use the App to knowingly solicit data from or market to children under the age of 13. The 
                    Company requests that such individuals not provide information through the App except through a parent or guardian. 
                    If a parent or guardian becomes aware that his or her child has provided the Company with information without the parent or guardian’s 
                    consent, he or she should contact the Company at [Company email address] and the Company will delete such information from its files. 
                </p>
                <br/>
                <h3>SECURITY</h3>
                <hr className={classes.line}/>
                <p>
                    The Company takes the security of its User’s information seriously. The Company takes such actions as are reasonably necessary to prevent 
                    unauthorized access to User Provided Information. The Company uses security and/or encryption technology, including SSL encrypted 
                    endpoints using the HTTPS protocol, to secure User Provided Information when it collects such information over the App or transmits 
                    such information to third party. The Company restricts access to User Provided Information on the Company servers and secures the content 
                    by use of encryption technologies and other security methods. However, the Company cannot guarantee that these practices will prevent every 
                    unauthorized attempt to access, use, or disclose User-Provided Information. Unfortunately, no data transmission over the Internet or data storage 
                    system is guaranteed to be 100% secure. For example, User-Provided Information saved in the App’s record may be accessed by an unauthorized party 
                    if the user’s smartphone or tablet is lost or stolen, or if the user’s user name and password for the App are otherwise made available to an 
                    unauthorized party. If you have reason to believe that your interaction with us is no longer secure (for example, if you feel that the security 
                    of any account you might have with us has been compromised), please immediately notify us of the problem by contacting us through the contact 
                    information provided below. Users enter individually identifiable information into the App at their own risk and should take appropriate steps to 
                    maintain the security of their information and the device. 
                </p>
                <br/>
                <h3>QUESTIONS</h3>
                <hr className={classes.line}/>
                <p>
                    If you have any questions about this Statement of Privacy Practices or CreedApp’s policies and practices concerning the App, 
                    you can contact CreedApp by telephone at +1 302-550-5959 or by U.S. mail at the address below:  
                </p>
                <p>
                    CreedApp,<br/>
                    David Wilk,<br/>
                    3521 Silverside Rd,<br/>
                    Suite 2F2,<br/>
                    Wilmington, DE 19801
                </p>
                <p>
                    Phone: +1 302-550-5959 <br/>
                    Email: <a href="mailto:wwcreed007@gmail.com">wwcreed007@gmail.com</a> <br/>
                    Effective: 11/1/2018
                </p>
            </div>
        </div>
    </Grid>
  );
}